import type { SimpleCardProps } from '@naf-simba/sections-cards';
import { ColorVariant } from '../../../types/featuredBenefitBlockType';

/**
 * Maps the colour variant the editor picks in Sanity onto Simba's `SimpleCard`.
 *
 * The retired `@naf/cards` `CardNavigation` took a single `colorVariant`; Simba
 * splits the same choice into `variant` (outline or filled) and `color`.
 */
export function getNavCardVariant(colorVariant?: ColorVariant): Pick<SimpleCardProps, 'variant' | 'color'> {
  switch (colorVariant) {
    case ColorVariant.signature:
      return { variant: 'filled', color: 'primary' };
    case ColorVariant.secondary:
    case ColorVariant.spruce:
      return { variant: 'filled', color: 'secondary' };
    default:
      return { variant: 'outline' };
  }
}
